import axios from 'axios'
import Cookies from 'js-cookie'
import { isFlutterApp, callFlutter } from 'android.js'

!Promise && require(['bluebird'], function(Promise) {
  window.Promise = window.Promise || Promise;
})

// 是否微信环境
let ua = navigator.userAgent.toLowerCase();
let isWeixin = ua && ~ua.indexOf('micromessenger');

const handleResponse = (res) => {
  // 支付接口使用的 status 判断
  if (res.data.errcode == 0 || res.data.success || res.data.status === 0) {
    return Promise.resolve(res.data)
  } else {

    // 填空题作答页面是iframe 登录后跳转需跳转至上层页面
    let newPathName = ~location.pathname.indexOf('/v/index/blanks/answer') ? window.parent.location.pathname : location.pathname

    // 用户session丢失
    if(res.data.op === 'redirect') {
      const sUrl = decodeURIComponent(res.data.url);
      const iNext = sUrl.indexOf('next=');
      let newUrl = sUrl.substring(0,iNext);

      
      newUrl += 'next=' + newPathName;
      setTimeout(() => {
        // 需要先登录
        if(isFlutterApp) {
          callFlutter('close_account', {})
        } else if(window.self != window.top) {
          window.top.location.href = '//' + location.host + newUrl;
        } else {
          location.href = '//' + location.host + newUrl;
        }
      }, 500)
      return;
    }

    if (res.data.op && res.data.op == 'web_redirect') {
      // 需要先登录
      if(isFlutterApp) {
        callFlutter('close_account', {})
      } else if(isWeixin) {
        // 测试发现部分接口没有判断ua 手机端请求的也返回的web_redirect 此处增加一层判断
        window.location.href = '/login/weixinapp/?next=' + newPathName;
      } else if(window.self != window.top) {
        window.top.location.href = '/web/?next=' + newPathName;
      } else {
        location.href = '/web/?next=' + newPathName;
      }
      
      return;
    }

    if(res.data.op && res.data.op === 'mobile_redirect') {
      // 需要先登录
      if(isFlutterApp) {
        callFlutter('close_account', {})
      } else if(window.self != window.top) {
        window.top.location.href = '/login/weixinapp/?next=' + encodeURIComponent(newPathName);
      } else {
        window.location.href = '/login/weixinapp/?next=' + encodeURIComponent(newPathName);
      }
      

      return;
    }

    if(res.data.op == 'redirect_bind'){
      // 清华绑定提示页
      window.location.href = '/static/html/tsinghua_bind.html'
      return;
    }

    if(res.data.op == 'k12_redirect_bind'){
      // k12绑定页面
      window.location.href = '/v/index/need-bind'
      return;
    }
    

    // 没有权限
    if( res.data.status_code === 2 || res.data.status_code === 4 || res.data.status_code === 902 ) {
      location.href = '/v/index/course/normalcourse/error/' + res.data.status_code;
    }

    // 云雨打通学习单元被删除
    if(res.data.error_code === 1 || res.data.error_code === 404000 || res.data.error_code === 902 ) {
      location.href = '/v/index/course/normalcourse/error/' + res.data.error_code;
    }
    if(res.data.error_code === 2 || res.data.error_code === 4 ){
      location.href = '/v/index/course/normalcourse/error/' + res.data.error_code + '?from=notice_view'
    }
    // 云雨打通接口错误 根据sub_code 判断异常原因
    if (res.data.error_code === 40000 && res.data.sub_code) {
      // sub_code为302 未做身份绑定 跳转至绑定提示页
      if (res.data.sub_code === 302) {
        location.href = '/static/html/tsinghua_bind.html?from=2'
      } 
    }
    // 没有填写信息 跳转个人信息完善页
    if(res.data.status_code === 5) {
      location.href = '/v/index/edituserinfo_simple?next_url=back';
    }

    if(res.data.node_status_code == '43002'){
      let lng = Cookies.get('django_language') || 'zh-cn';
      if(window.Toast){
        Toast({
          message: lng == 'zh-cn'?'输入内容含敏感词，请检查后重试':'The input contains sensitive words, please check and try again.' ,
          duration: 3000
        });
      }

      return;
    }
    if (res.data.error_code == '500600' || res.data.error_code == '500500' || res.data.error_code == '500700' || res.data.errcode == '300413') {

      if(window.Toast){
        Toast({
          message: (res.data.data && res.data.data.data && res.data.data.data.msg) || res.data.msg,
          duration: 3000
        });
      }
      return Promise.resolve(res.data)
    }

    // 
    if(res.data.msg === 'CSRF cookie not set.') {
      if(isFlutterApp) {
        callFlutter('close_account', {})
      } else if(window.self != window.top) {
        if(isWeixin) {
          window.top.location.href = '/login/weixinapp/?next=' + newPathName;
        } else {
          window.top.location.href = '/web/?next=' + newPathName;
        }
      } else {
        
        if(isWeixin) {
          window.location.href = '/login/weixinapp/?next=' + newPathName;
        } else {
          window.location.href = '/web/?next=' + newPathName
        }
      }
    }

    return Promise.reject(res.data)
  }
}

// 设置请求的设备和sessionid
if (localStorage) {
  let sessionid = localStorage.getItem('sessionid')
  let client = localStorage.getItem('x-client') || 'web'
  if (sessionid) {
    axios.defaults.headers['x-mobile-sessid'] = sessionid
  }
  axios.defaults.headers['x-client'] = client
  axios.defaults.headers['xtbz'] = 'ykt';
}

axios.defaults.headers['Xt-Agent'] = "h5";

function errRequest(error) {
  const { response = {} } = error;
  if(response.status === 401) {
    const { data = {} } = response;
    const { error_code } = data;
    const op = data.data && data.data.op
    if (error_code === 20006) {
      console.log(op)
      if (op === "mobile_redirect") {
        window.location.href = '/static/html/openinwx.html'
        return;
      }
      if (op === "redirect") {
        location.href = '/login/weixinapp/?next=' + encodeURIComponent(location.href);
        return;
      }
    }
  }
}

export default {
  get (url, params,allowEmpty) {
    params = params || {}
    let queryString = []

    Object.keys(params).forEach(key => {
      if(!allowEmpty){
        params[key] && queryString.push(`${key}=${params[key]}`)
      }else{
        queryString.push(`${key}=${params[key]}`)
      }
    })

    if (queryString.length > 0) {
      queryString = queryString.join('&')
      url += `?${queryString}`
    }
    if (url.indexOf('?')>-1) {
        url += "&date_time=" +new Date().getTime();
    } else {
        url += "?date_time=" +new Date().getTime();
    }

    let classroomid = localStorage.getItem('classroomId')
    let uv_id = localStorage.getItem('uv_id')
    classroomid && (axios.defaults.headers['classroom-id'] = classroomid)
    uv_id && (axios.defaults.headers['university-id'] = uv_id)
    return axios
      .get(url)
      .then(function (response, data) {
        return response
      })
      .then(handleResponse)
      .catch(error => {
        errRequest(error)
        return Promise.reject(error)
      })
  },

  post (url, params, headers={}) {
    params = params || {}

    // post统一csrftoken
    axios.defaults.headers['X-CSRFToken'] = Cookies.get('csrftoken') || ''

    let classroomid = localStorage.getItem('classroomId')
    let uv_id = localStorage.getItem('uv_id')
    classroomid && (axios.defaults.headers['classroom-id'] = classroomid)
    uv_id && (axios.defaults.headers['university-id'] = uv_id)

    return axios
      .post(url, params,{headers})
      .then(function (response, data) {
        return response
      })
      .then(handleResponse)
      .catch(error => {
        errRequest(error)
        return Promise.reject(error)
      })
  },
  put (url, params) {
    params = params || {}

    // put统一csrftoken
    axios.defaults.headers['X-CSRFToken'] = Cookies.get('csrftoken') || ''

    return axios
      .put(url, params)
      .then(function (response, data) {
        return response
      })
      .then(handleResponse)
      .catch(error => {
        return Promise.reject(error)
      })
  },

  delete (url, params) {
    params = params || {}
     
    let queryString = []
    axios.defaults.headers['X-CSRFToken'] = Cookies.get('csrftoken') || ''
    // delete统一csrftoken
    Object.keys(params).forEach(key => {
      queryString.push(`${key}=${params[key]}`)
    })

    if (queryString.length > 0) {
      queryString = queryString.join('&')
      url += `?${queryString}`
    }
    if (url.indexOf('?')>-1) {
        url += "&date_time=" +new Date().getTime();
    } else {
        url += "?date_time=" +new Date().getTime();
    }

    return axios
      .delete(url, params)
      .then(function (response, data) {
        return response
      })
      .then(handleResponse)
      .catch(error => {
        return Promise.reject(error)
      })
  },
}



// WEBPACK FOOTER //
// ./src/util/request2.js